import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import ForgotPassword from './Pages/ForgotPassword';
import './App.css';
import './scss/style.scss'
import "./css/Global.css"

import { RecoilRoot } from 'recoil';
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const Login = React.lazy(() => import('./Pages/Login'))
const DoctorRegister = React.lazy(() => import('./Pages/DoctorRegister'))
const DoctorClinicSelections = React.lazy(() => import('./Pages/DoctorClinicSelection'))
const FileReader = React.lazy(() => import('./Pages/FileReader'))

global.VERSION = "1.0.0";

global.HOME_MENU = [
  {
    "description": "Book Appointment ",
    "routing_name": "Appointment",
    "internal_routing": "",
    "icon_home": "schedule.png",
    "icon_menu": "schedule.png",
    "sort_order_home": "1",
    "role": "dc",
    "screen_id_fk": "77",
    "is_desktop": "0",
    "is_mobile": "1"
  },
  {
    "description": "View Appointments -P",
    "routing_name": "ViewAppointmentsMobViewTwo",
    "internal_routing": "NewPatientEditInfo",
    "icon_home": "doctor-appointment.png",
    "icon_menu": "doctor-appointment.png",
    "sort_order_home": "2",
    "role": "dc",
    "screen_id_fk": "42",
    "is_desktop": "0",
    "is_mobile": "1"
  },
  {
    "description": "Patients Check In -m",
    "routing_name": "PatientsCheckin",
    "internal_routing": "NewPatientRegister,UploadRecords",
    "icon_home": "patientscheckin.png",
    "icon_menu": "patientscheckin.png",
    "sort_order_home": "3",
    "role": "dc",
    "screen_id_fk": "2",
    "is_desktop": "0",
    "is_mobile": "1"
  },
  {
    "description": "Patient's Info",
    "routing_name": "ClinicPatients",
    "internal_routing": "ViewRecords,ViewBio,PatientHistory,ConsultationList",
    "icon_home": "patientsinfo.png",
    "icon_menu": "patientsinfo.png",
    "sort_order_home": "7",
    "role": "dc",
    "screen_id_fk": "76",
    "is_desktop": "0",
    "is_mobile": "1"
  }
];

global.LAB_HOME_MENU = [
  {
    "description": "View Lab Appointment",
    "routing_name": "LabViewAppointments",
    "internal_routing": "LabNewPatientRegister",
    "icon_home": "doctor-appointment.png",
    "icon_menu": "doctor-appointment.png",
    "sort_order_home": "0",
    "role": "radadm",
    "screen_id_fk": "150",
    "is_desktop": "0",
    "is_mobile": "1"
  },
  {
    "description": "Book Lab Appointment",
    "routing_name": "LabAppointment",
    "internal_routing": "LabSlotSelection, LabPatientDetails, LabConfirmation",
    "icon_home": "schedule.png",
    "icon_menu": "schedule.png",
    "sort_order_home": "0",
    "role": "radadm",
    "screen_id_fk": "149",
    "is_desktop": "0",
    "is_mobile": "1"
  },
  {
    "description": "LAB Patients Check In -m",
    "routing_name": "LabPatientsCheckin",
    "internal_routing": "LabNewPatientRegister,LabUploadRecords",
    "icon_home": "patientscheckin.png",
    "icon_menu": "patientscheckin.png",
    "sort_order_home": "0",
    "role": "radadm",
    "screen_id_fk": "151",
    "is_desktop": "0",
    "is_mobile": "1"
  }
];

global.DOCTOR_HOME_MENU = [
  {
    "description": "View Appointments -P",
    "routing_name": "ViewAppointmentsMobViewTwo",
    "internal_routing": "NewPatientEditInfo",
    "icon_home": "doctor-appointment.png",
    "icon_menu": "doctor-appointment.png",
    "sort_order_home": "2",
    "role": "rd",
    "screen_id_fk": "42",
    "is_desktop": "0",
    "is_mobile": "1"
  },
  {
    "description": "Patients Check In -m",
    "routing_name": "PatientsCheckin",
    "internal_routing": "NewPatientRegister,UploadRecords",
    "icon_home": "patientscheckin.png",
    "icon_menu": "patientscheckin.png",
    "sort_order_home": "3",
    "role": "rd",
    "screen_id_fk": "2",
    "is_desktop": "0",
    "is_mobile": "1"
  },
  {
    "description": "Doctors Scratch Pad",
    "routing_name": "DoctorsNotePad",
    "internal_routing": "",
    "icon_home": "notepad.png",
    "icon_menu": "notepad.png",
    "sort_order_home": "5",
    "role": "rd",
    "screen_id_fk": "88",
    "is_desktop": "1",
    "is_mobile": "1"
  }
]

global.genderList = [
  {
    label: "Male",
    value: "Male"
  },
  {
    label: "Female",
    value: "Female"
  },
  {
    label: "Others",
    value: "other"
  }
]

global.DATE_FORMAT = 'DD-MMM-YYYY';
global.DATE_TIME_FORMAT = 'DD-MMM-YYYY hh:mm A';
global.DATE_DAY_FORMAT = 'DD-MMM-YYYY ddd';

global.formatName = (name) => {
  if (!name) return '';
  return name.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};

class App extends Component {
  render() {
    return (
      <RecoilRoot>
        <HashRouter>
          <Suspense fallback={loading}>
            <Routes>
              <Route exact path="/" element={<Login />} />
              <Route exact path="/ForgotPassword" element={<ForgotPassword />} />
              <Route path="/DoctorRegister" element={<DoctorRegister />} />
              <Route path="/SelectClinic" element={<DoctorClinicSelections />} />
              <Route path="/FileReader" name="FileReader" element={<FileReader />} />
              <Route path="*" name="Home" element={<DefaultLayout />} />
            </Routes>
          </Suspense>
        </HashRouter>
      </RecoilRoot>
    )
  }
}

export default App